const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "sail_dx_token";

/**
 * Posts to an SSE endpoint and calls onDelta with each text piece as it arrives.
 * Resolves with the final payload the server sent on the `done` event.
 */
export async function streamAssistant(path, body, onDelta) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ""}`,
    },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const j = await res.json();
      if (j?.detail) detail = typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
    } catch {
      /* non-JSON error body */
    }
    throw new Error(detail);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let final = {};

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split("\n\n");
    buffer = chunks.pop() || "";
    for (const chunk of chunks) {
      const line = chunk.split("\n").find((l) => l.startsWith("data: "));
      if (!line) continue;
      let event;
      try {
        event = JSON.parse(line.slice(6));
      } catch {
        continue;
      }
      if (event.error) throw new Error(event.error);
      if (event.delta) onDelta(event.delta);
      if (event.session_id) final.session_id = event.session_id;
      if (event.done) final.done = true;
    }
  }
  return final;
}
